import { AppProps } from 'next/app';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { shouldTrackAwin } from '@husslehq/api-client-ts/dist/awin-tracking/should-track-awin';

import { initialize as initializeAnalytics } from '../services/analytics';

import '../styles/globals.scss';
import '@husslehq/ui-library/lib/bundle.esm.css';

function MyApp({ Component, pageProps }: AppProps): JSX.Element {
  const { query } = useRouter();

  useEffect(() => {
    if (typeof document !== 'undefined') {
      initializeAnalytics({ id: process.env.NEXT_PUBLIC_GTM_ID || 'GTM-T39S42S' });
    }
  }, []);

  useEffect(() => {
    if (!shouldTrackAwin(query)) return;
    (async function () {
      const { trackAwin } = await import('@husslehq/api-client-ts');
      await trackAwin({
        awc: query.awc as string,
        affid: query.affid as string | undefined,
        cookie: document.cookie,
      });
    })();
  }, [query]);

  return (
    <>
      <Component {...pageProps} />
    </>
  );
}

export default MyApp;
